



































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Button as ElButton, ButtonGroup } from 'element-ui'

@Component({
  name: 'JsfArrayItemActions',
  components: {
    ButtonGroup,
    ElButton,
  },
})
export default class JsfAlert extends Vue {
  @Prop({ required: true, type: Function }) onDelete: any
  @Prop({ required: true, type: Function }) onAdd: any
  @Prop({ required: true, type: Function }) onUp: any
  @Prop({ required: true, type: Function }) onDown: any
  // @Prop({ required: true, type: Function }) onToggle: any
  @Prop({ required: true }) item: any
  @Prop({ required: true, type: Number }) index: any
  @Prop({ required: true, type: Number }) length: any
  // @Prop({ required: true, type: Boolean }) show: any

  handleClick(type: string) {
    const self: any = this
    self[type](this.item, this.index)
  }
}
